<template>
  <div>{{ zone }}</div>
</template>

<script>
export default {
  name: 'tdTruck',
  props: ['row'],
  computed: {
    zone() {
      if (!this.row.zone) {
        return 'N/A'
      } else {
        return `${this.row.zone} (${this.row.region})`
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/OrderTable/components/tdZone.vue